const SIZE_BUCKETS = [50, 100, 150, 200, 300, 400, 600, 800, 1000, 1200, 1500, 2000, 3000]

function snapToBucket (size) {
  for (const bucket of SIZE_BUCKETS) {
    if (size <= bucket) { return bucket }
  }
  return SIZE_BUCKETS[SIZE_BUCKETS.length - 1]
}

function smallImageURL (originURL, width, height, isCut = true) {
  if (!originURL) {
    return ''
  }
  const pixelRatio = window.devicePixelRatio || 1
  const resizeMode = isCut ? 'm_fill' : 'm_lfit'

  const params = []
  const resizeParts = []
  if (width) { resizeParts.push(`w_${snapToBucket(Math.ceil(width * pixelRatio))}`) }
  if (height) { resizeParts.push(`h_${snapToBucket(Math.ceil(height * pixelRatio))}`) }
  resizeParts.push(resizeMode)
  params.push(`resize,${resizeParts.join(',')}`)
  params.push(`quality,q_95`)
  params.push(`format,webp`)

  const processParams = params.join('/')
  if (originURL.includes('?')) {
    return `${originURL},${processParams}`
  }
  return `${originURL}?x-oss-process=image/${processParams}`
}

export { smallImageURL }
